import { z } from 'zod';
import { SubscriptionPlanName } from '../types/subscription-plan';
import { UserId } from './auth-user';

import { IBaseEntity } from './base-entity.interface';
import { Subscription } from './subscription';

export const OrganizationIdSchema = z.string().brand('OrganizationId');
export type OrganizationId = z.infer<typeof OrganizationIdSchema> | string;

/**
 * An organization is a group of users that can share targets and scans
 */
export interface Organization extends IBaseEntity {

    /**
     * The unique identifier for the organization
     */
    id: OrganizationId;

    /**
     * The name of the organization
     */
    name: string;

    /**
     * The Stripe customer ID for this organization, if applicable
     */
    stripeCustomerId?: string;

    /**
     * The subscription plan for this organization
     */
    plan: SubscriptionPlanName;

    /**
     * The number of starter audits available for this organization
     */
    starterAudits?: number;

    /**
     * The subscription of this organization, if resolved
     */
    subscription?: Subscription;

    /**
     * The user ID this organization's owner
     */
    ownerId: UserId;

    /**
     * The Featurebase identity verification hash for this organization
     */
    featurebaseIdentityVerificationHash?: string;
}
